import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, MenuItem, TextField } from '@mui/material';
import api from '../../../api/api';

export default function ReturnPointSelect({ value, onChange, required, disabled }) {
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setLoading(true); setError(false);
    api.get('/rental-points/', { skipLoading: true, signal: controller.signal })
      .then(response => {
        if (active) setPoints((Array.isArray(response.data) ? response.data : []).filter(point => !point.has_cells));
      })
      .catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; controller.abort(); };
  }, [attempt]);

  return <Box sx={{ mb: 2 }}>
    <TextField select fullWidth label="Фактический ПВЗ возврата" value={value} required={required}
      disabled={disabled || loading || error} onChange={event => onChange(event.target.value)}
      helperText={loading ? 'Загружаем ПВЗ…' : required
        ? 'После выдачи из постамата выберите ПВЗ, где сотрудник принимает вещь.'
        : 'Если вещь сдают в другом ПВЗ, укажите его здесь.'}>
      <MenuItem value="">{required ? 'Выберите ПВЗ' : 'ПВЗ первоначальной выдачи'}</MenuItem>
      {points.map(point => <MenuItem key={point.id} value={point.id}>{point.name}{point.address ? ` · ${point.address}` : ''}</MenuItem>)}
    </TextField>
    {error && <Alert severity="error" sx={{ mt: 1 }}>Не удалось загрузить ПВЗ.<Button disabled={disabled} onClick={() => setAttempt(value => value + 1)}>Повторить загрузку ПВЗ</Button></Alert>}
    {!loading && !error && points.length === 0 && <Alert severity="warning" sx={{ mt: 1 }}>Нет ПВЗ для приёма возврата. Добавьте обычный пункт проката в настройках бизнеса.</Alert>}
  </Box>;
}
